import { render, staticRenderFns } from "./feedback-head.vue?vue&type=template&id=1157230b"
import script from "./feedback-head.vue?vue&type=script&lang=js"
export * from "./feedback-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports